module.exports = __webpack_public_path__ + "static/img/mingf15.0f6ad6a1.png";